import React, { Component } from 'react';

class UserExceptionGrid extends Component {
  render() {
    const { items, onDelete, onAdd } = this.props;
    return (<div className="table-responsive">
      <table className="table table-hover">
        <thead>
        <tr>
          <th scope="col" style={{ width: '90%' }}>Email</th>
          <th scope="col">
            <button className="btn  btn-light" onClick={onAdd}><i
              className="fas fa-plus-circle text-black"></i>
            </button>
          </th>
        </tr>
        </thead>
        <tbody>
        {items.map(m => (<tr key={m.id}>
          <td scope="col">{m.email}</td>
          <td scope="col">
            <button className="btn  btn-light" onClick={() => onDelete(m.id)}><i
              className="fas fa-trash text-black"></i></button>
          </td>
        </tr>))}
        </tbody>
      </table>
    </div>);
  }
}

export default UserExceptionGrid;